export default __webpack_public_path__ + "static/media/ART8.98204b09.jpg";